import { apiSlice } from "./authApi";

export const patientPrescriptionApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getPrescriptionsByPatientId: builder.query({
            query: ({ patientId, page = 1, pageSize = 10 }) => ({
                url: `/patients/${patientId}/prescriptions/`,
                method: "GET",
                params: { page, pageSize },
            }),
            providesTags: (result, error, { patientId }) => [
                { type: "PatientPrescription", patientId },
            ],
            transformResponse: response => ({
                results: response.results,
                count: response.count
            }),
            keepUnusedDataFor: 5,
        }),

        // Fetch a single prescription by patient ID and prescription ID
        getPatientPrescription: builder.query({
            query: ({ patientId, presId }) => ({
                url: `/patients/${patientId}/prescriptions/${presId}/`,
                method: "GET",
            }),
            providesTags: (result, error, { presId }) => [
                { type: "PatientPrescription", presId },
            ],
        }),

        // Create a new prescription for a specific patient by patient ID
        createPatientPrescription: builder.mutation({
            query: ({ patientId, newPrescription }) => ({
                url: `/patients/${patientId}/prescriptions/`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: newPrescription,
            }),
            invalidatesTags: (result, error, { patientId }) => [
                { type: "PatientPrescription", patientId },
            ],
        }),

        // Update an existing prescription by patient ID and prescription ID
        updatePatientPrescription: builder.mutation({
            query: ({ patientId, presId, ...update }) => ({
                url: `/patients/${patientId}/prescriptions/${presId}/`,
                method: "PATCH",
                body: update,
                headers: {
                    "Content-Type": "application/json",
                },
            }),
            invalidatesTags: (result, error, { presId }) => [
                { type: "PatientPrescription", presId },
            ],
        }),

        // Delete a prescription by patient ID and visit ID
        deletePatientPrescription: builder.mutation({
            query: ({ patientId, presId }) => ({
                url: `/patients/${patientId}/prescriptions/${presId}/`,
                method: "DELETE",
            }),
            invalidatesTags: (result, error, { presId }) => [
                { type: "PatientPrescription", presId },
            ],
        }),
    }),
});

export const {
    useGetPrescriptionsByPatientIdQuery,
    useGetPatientPrescriptionQuery,
    useCreatePatientPrescriptionMutation,
    useUpdatePatientPrescriptionMutation,
    useDeletePatientPrescriptionMutation,
} = patientPrescriptionApiSlice;
